import styled from "styled-components";
import TextArea from "@8x8/oxygen-textarea";
import { CopyTextButton } from "@/react/features/support-tools/encryption/styled";

const TextAreaWrapper = styled.div`
  display: flex;
  position: relative;
  width: calc(100% - 32px);
  margin-top: 16px;
`;

const GeneratedTextArea = ({ value, rows }) => {
  return (
    <TextAreaWrapper>
      <TextArea rows={rows} value={value} />
      <CopyTextButton value={value} />
    </TextAreaWrapper>
  );
};

export default GeneratedTextArea;
